import htmlToPdfMake from 'html-to-pdfmake'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { languages } from '../../../../configs/language'
import logoFiinGateEN from '../../../common/icons/logoFiinGateEN.svg'
import logoFiinGateVI from '../../../common/icons/logoFiinGateVI.svg'
import { selectCompanyInfo } from '../../../companyAnalysis/common/header/companyInfo/store/slice'
import EventEmitter, {
  END_PROCESS_DOWNLOAD_PDF,
  SHOW_POPUP_PDF,
} from '../../../helpers/EventEmitter'
import {
  FORMAT,
  formatDateTime,
  getCurrentDateTime,
} from '../../../helpers/datetime'
import {
  DEFAULT_REPORT_TITLE,
  PADDING_PDF,
  TYPE_DOWNLOAD,
  TYPE_ITEM_PDF,
} from '../constant'
import { getIdToc } from '../helper'
import classes from '../index.module.scss'
import { selectNamePortActive } from '../preferenceSetting/detailTemplate/store/slice'
import { uploadFileDynamic } from '../store/thunk'
import coverPageImg from './coverPageImg.png'

pdfMake.vfs = pdfFonts.pdfMake.vfs

const imgCoverPage = new Image()
imgCoverPage.src = coverPageImg
imgCoverPage.crossOrigin = 'anonymous'

const imageLogoFiinGateEN = new Image()
imageLogoFiinGateEN.src = logoFiinGateEN
imageLogoFiinGateEN.crossOrigin = 'anonymous'

const imageLogoFiinGateVI = new Image()
imageLogoFiinGateVI.src = logoFiinGateVI
imageLogoFiinGateVI.crossOrigin = 'anonymous'

export const DownloadPdfFile = ({
  children,
  setDefault,
  typeDownload,
  coverPage,
  data,
}) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const companyInfo = useSelector(selectCompanyInfo)
  const namePort = useSelector(selectNamePortActive)

  const pdfRef = useRef()

  const imageLogo =
    locale === languages.en ? imageLogoFiinGateEN : imageLogoFiinGateVI

  const downloadPdf = () => {
    if (pdfRef.current) {
      const htmlPdfMake = htmlToPdfMake(`${pdfRef.current.innerHTML}`, {
        imagesByReference: true,
        defaultStyles: {},
        tableAutoSize: true,
      })

      const getPdfFooter = () => {
        return {
          stack: [
            {
              table: {
                widths: ['auto', '*', 'auto'],
                body: [
                  [
                    {
                      text: 'FIINGATE DYNAMIC REPORT',
                      margin: [50, 8, 0, 8],
                      color: '#fff',
                      fontSize: 12,
                    },
                    {
                      text: I18n.t('dynamicReport.MORE_AT'),
                      alignment: 'right',
                      margin: [0, 8, 0, 8],
                      color: '#fff',
                      fontSize: 12,
                      bold: true,
                    },
                    {
                      text: ' www.fiingate.vn',
                      margin: [0, 8, 50, 8],
                      color: '#fff',
                      fontSize: 12,
                    },
                  ],
                ],
              },
              fillColor: '#6b6b6b',
              layout: 'noBorders',
            },
          ],
          margin: [0, 16, 0, 0],
        }
      }

      const c = document.createElement('canvas')
      const ctx = c.getContext('2d')
      c.width = 260 * 5
      c.height = 56 * 5
      ctx.drawImage(imageLogo, 0, 0, 260 * 5, 56 * 5)
      const logo = c.toDataURL('image/jpg')

      const reportTitle = (
        coverPage.reportTitle.trim() || DEFAULT_REPORT_TITLE
      ).toUpperCase()

      const reportSubtitle =
        coverPage.isHasReportSubtitle && coverPage.reportSubtitle.trim()
          ? coverPage.reportSubtitle.trim()
          : null

      const companyName = coverPage?.isHasCompanyName
        ? companyInfo?.organizationName
        : null
      const portName = coverPage?.isHasPortName ? namePort : null

      const getPdfHeader = (currentPage, _, { orientation }) => {
        const isLandscape = orientation === 'landscape'
        const contentPageNumber =
          docDefinition.content[5].positions[0]?.pageNumber ||
          docDefinition.content[6].positions[0]?.pageNumber
        const isContentPage = currentPage >= contentPageNumber
        const extendHeader = isContentPage
          ? [
              { text: '' },
              {
                text: currentPage,
                alignment: 'center',
                margin: [0, 12, 0, 12],
                color: '#FFFFFF',
                fillColor: '#34609e',
                fontSize: 14,
                bold: true,
              },
            ]
          : []
        const extendWidth = isContentPage ? [isLandscape ? 486 : 240, 100] : []

        return {
          stack: [
            {
              layout: 'noBorders',
              table: {
                widths: [140, ...extendWidth],
                body: [
                  [
                    {
                      image: logo,
                      width: 140,
                      margin: [0, 10, 0, 0],
                    },
                    ...extendHeader,
                  ],
                ],
              },
            },
          ],
          margin: [50, 0, 50, 0],
        }
      }

      const c2 = document.createElement('canvas')
      const ctx2 = c2.getContext('2d')
      c2.width = 595 * 5
      c2.height = 610 * 5
      ctx2.drawImage(imgCoverPage, 0, 0, 595 * 5, 610 * 5)
      const imgBgCoverPage = c2.toDataURL('image/jpg')

      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [PADDING_PDF, 85, PADDING_PDF, PADDING_PDF],
        header: getPdfHeader,
        footer: getPdfFooter(),
        background: (currentPage) => {
          if (currentPage === 1) {
            return {
              image: imgBgCoverPage,
              width: 595,
              absolutePosition: { x: 0, y: 60 },
            }
          }
          return
        },
        content: [
          {
            absolutePosition: { x: 0, y: 130 },
            layout: {
              hLineWidth: () => 4,
              vLineWidth: () => 4,
              paddingLeft: () => -4,
              paddingRight: () => -4,
            },
            table: {
              headerRows: 0,
              widths: [56, 137, 358, 56],
              body: [
                [
                  {
                    text: ' ',
                    fillColor: '#3867ab',
                    fillOpacity: 0.95,
                    margin: [0, 25, 0, 0],
                    border: [false, false, false, false],
                  },
                  {
                    text: DEFAULT_REPORT_TITLE,
                    bold: true,
                    fontSize: 12,
                    color: '#FFFFFF',
                    margin: [0, 25, 0, 0],
                    fillColor: '#3867ab',
                    fillOpacity: 0.95,
                    border: [false, false, false, true],
                    borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'],
                  },
                  {
                    text:
                      I18n.t('dynamicReport.DATE_OF_REPORT') +
                      getCurrentDateTime(FORMAT.DATE, locale),
                    bold: true,
                    fontSize: 12,
                    color: '#FFFFFF',
                    margin: [0, 25, 0, 0],
                    alignment: 'right',
                    fillColor: '#3867ab',
                    fillOpacity: 0.95,
                    border: [false, false, false, false],
                  },
                  {
                    text: ' ',
                    fillColor: '#3867ab',
                    fillOpacity: 0.95,
                    margin: [0, 25, 0, 0],
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          {
            absolutePosition: { x: 0, y: 178 },
            layout: 'noBorders',
            table: {
              headerRows: 0,
              widths: [595],
              body: [
                [
                  {
                    text: reportTitle,
                    bold: true,
                    fontSize: 25,
                    color: '#FFFFFF',
                    margin: [
                      50,
                      15,
                      50,
                      reportSubtitle || companyName || portName ? 0 : 25,
                    ],
                    fillColor: '#3867ab',
                    fillOpacity: 0.95,
                  },
                ],
                ...(companyName
                  ? [
                      [
                        {
                          text:
                            I18n.t('dynamicReport.COMPANY') +
                            ': ' +
                            companyName,
                          bold: true,
                          fontSize: 10,
                          color: '#FFFFFF',
                          alignment: 'justify',
                          margin: [50, 0, 50, 10],
                          fillColor: '#3867ab',
                          fillOpacity: 0.95,
                        },
                      ],
                    ]
                  : []),
                ...(portName
                  ? [
                      [
                        {
                          text: I18n.t('dynamicReport.PORT') + ': ' + portName,
                          bold: true,
                          fontSize: 10,
                          color: '#FFFFFF',
                          alignment: 'justify',
                          margin: [50, 0, 50, 10],
                          fillColor: '#3867ab',
                          fillOpacity: 0.95,
                        },
                      ],
                    ]
                  : []),
                ...(reportSubtitle
                  ? [
                      [
                        {
                          text:
                            I18n.t('dynamicReport.SUBTITLE') +
                            ': ' +
                            reportSubtitle,
                          bold: true,
                          fontSize: 10,
                          color: '#FFFFFF',
                          alignment: 'justify',
                          margin: [50, 0, 50, 25],
                          fillColor: '#3867ab',
                          fillOpacity: 0.95,
                        },
                      ],
                    ]
                  : []),
              ],
            },
          },
          {
            absolutePosition: { x: 0, y: 700 },
            widths: [297.5, 297.5],
            columns: [
              {
                layout: 'noBorders',
                table: {
                  headerRows: 0,
                  widths: [297.5],
                  body: [
                    [
                      {
                        text: I18n.t('dynamicReport.HEAD_OFFICE'),
                        bold: true,
                        fontSize: 9,
                        color: '#033363',
                        margin: [65, 0, 18, 0],
                      },
                    ],
                    [
                      {
                        text: I18n.t('dynamicReport.HN_ADDRESS'),
                        fontSize: 9,
                        color: '#234891',
                        margin: [65, 8, 18, 0],
                      },
                    ],
                    [
                      {
                        text:
                          I18n.t('dynamicReport.PHONE') + '+84 24 3562 6962',
                        fontSize: 9,
                        color: '#234891',
                        margin: [65, 0, 18, 0],
                      },
                    ],
                    [
                      {
                        text:
                          I18n.t('dynamicReport.EMAIL') +
                          'support.fiingate@fiingroup.vn',
                        fontSize: 9,
                        color: '#234891',
                        margin: [65, 0, 18, 0],
                      },
                    ],
                  ],
                },
              },
              {
                layout: 'noBorders',
                table: {
                  headerRows: 0,
                  widths: [297.5],
                  body: [
                    [
                      {
                        text: I18n.t('dynamicReport.HCM_BRANCH'),
                        bold: true,
                        fontSize: 9,
                        color: '#033363',
                        margin: [18, 0, 65, 0],
                      },
                    ],
                    [
                      {
                        text: I18n.t('dynamicReport.HCM_ADDRESS'),
                        fontSize: 9,
                        color: '#234891',
                        margin: [18, 8, 65, 0],
                      },
                    ],
                    [
                      {
                        text:
                          I18n.t('dynamicReport.PHONE') + '+84 28 3933 3586',
                        fontSize: 9,
                        color: '#234891',
                        margin: [18, 0, 65, 0],
                      },
                    ],
                    [
                      {
                        text:
                          I18n.t('dynamicReport.EMAIL') +
                          'support.fiingate@fiingroup.vn',
                        fontSize: 9,
                        color: '#234891',
                        margin: [18, 0, 65, 0],
                      },
                    ],
                  ],
                },
              },
            ],
          },
          {
            text: I18n.t('dynamicReport.TABLE_OF_CONTENT'),
            pageBreak: 'before',
            fontSize: 18,
            bold: true,
            marginBottom: 30,
            color: '#033363',
          },
          {
            layout: 'noBorders',
            table: {
              widths: [450, 45],
              body: data.reduce((toc, { page, items }) => {
                items.forEach(({ type, title, subTitle }, index) => {
                  if (type === TYPE_ITEM_PDF.CHAPTER_HEADER) {
                    toc.push([
                      {
                        textReference: getIdToc(page, index),
                        fontSize: 10,
                        bold: true,
                        color: '#234891',
                        margin: [0, 0, 0, 5],
                      },
                      {
                        pageReference: getIdToc(page, index),
                        fontSize: 10,
                        color: '#234891',
                        margin: [0, 0, 0, 5],
                        alignment: 'right',
                      },
                    ])
                  } else if (type === TYPE_ITEM_PDF.TITLE_PANEL) {
                    toc.push([
                      {
                        fontSize: 10,
                        margin: [20, 0, 0, 5],
                        text: [
                          {
                            text: I18n.t(title) + ' ',
                            fontSize: 10,
                            bold: true,
                            color: '#234891',
                          },
                          {
                            text: subTitle ? I18n.t(subTitle) : '',
                            fontSize: 10,
                            color: '#234891',
                            italics: true,
                          },
                        ],
                      },
                      {
                        pageReference: getIdToc(page, index),
                        fontSize: 10,
                        margin: [0, 0, 0, 5],
                        alignment: 'right',
                      },
                    ])
                  } else if (type === TYPE_ITEM_PDF.CONTENT_PANEL && title) {
                    // add title TOC currency unit FS
                    toc.push([
                      {
                        textReference: getIdToc(page, index),
                        fontSize: 10,
                        margin: [40, 0, 0, 5],
                      },
                      {
                        pageReference: getIdToc(page, index),
                        fontSize: 10,
                        margin: [0, 0, 0, 5],
                        alignment: 'right',
                      },
                    ])
                  }
                })
                return toc
              }, []),
            },
          },
          ...htmlPdfMake.content,
          {
            text: I18n.t('dynamicReport.NOTE_CURRENCY_UNIT'),
            margin: [0, 20, 0, 0],
            color: '#3A414B',
            italics: true,
            fontSize: 10,
            alignment: 'justify',
          },
          {
            pageBreak: 'before',
            layout: 'noBorders',
            margin: [0, 15, 0, 0],
            pageOrientation: 'portrait',
            table: {
              headerRows: 0,
              widths: ['100%'],
              body: [
                [
                  {
                    text: I18n.t('dynamicReport.DISCLAIMER_TITLE'),
                    bold: true,
                    fontSize: 10,
                    fillColor: '#F3F3F3',
                    margin: [16, 12, 16, 0],
                  },
                ],
                [
                  {
                    text: I18n.t('dynamicReport.DISCLAIMER_1'),
                    alignment: 'justify',
                    fontSize: 10,
                    fillColor: '#F3F3F3',
                    margin: [16, 8, 16, 0],
                  },
                ],
                [
                  {
                    text: I18n.t('dynamicReport.DISCLAIMER_2'),
                    fontSize: 10,
                    alignment: 'justify',
                    fillColor: '#F3F3F3',
                    margin: [16, 0, 16, 0],
                  },
                ],
                [
                  {
                    text: I18n.t('dynamicReport.DISCLAIMER_3'),
                    fontSize: 10,
                    fillColor: '#F3F3F3',
                    margin: [16, 0, 16, 12],
                  },
                ],
              ],
            },
          },
        ],
        images: htmlPdfMake.images,
      }

      if (typeDownload === TYPE_DOWNLOAD.DOWNLOAD) {
        pdfMake.createPdf(docDefinition).getBlob(async (blob) => {
          const nameFileDownload = `FG_DynamicReport_${formatDateTime(
            new Date(),
            FORMAT.FILE_DOWNLOAD,
          )}.pdf`

          let filePdfToServer = new File([blob], nameFileDownload, {
            type: 'application/pdf',
          })

          let bodyFormData = new FormData()

          bodyFormData.append('file', filePdfToServer)

          await dispatch(uploadFileDynamic(bodyFormData)).unwrap()

          await pdfMake.createPdf(docDefinition).download(nameFileDownload)

          setDefault()
          EventEmitter.dispatch(END_PROCESS_DOWNLOAD_PDF)
        })
      } else {
        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          const url = URL.createObjectURL(blob)

          EventEmitter.dispatch(SHOW_POPUP_PDF, {
            messages: (
              <iframe
                title="PreviewPdf"
                style={{
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  border: 'none',
                }}
                src={`${url}#toolbar=0`}
              />
            ),
            blobData: blob,
            docDefinition,
          })
        })
        setDefault()
        EventEmitter.dispatch(END_PROCESS_DOWNLOAD_PDF)
      }
    }
  }

  useEffect(() => {
    downloadPdf()
  }, [])

  return (
    <div className={classes.pdfContainer}>
      <div ref={pdfRef}>{children()}</div>
    </div>
  )
}
